import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormValue, setValidValue } from "../contractorSlice";

export const useContractorField = (fieldName, options = {}) => {
  const dispatch = useDispatch();
  const formValues = useSelector((state) => state.contractor.formValues);

  const [touched, setTouched] = useState(false);
  const value = formValues[fieldName] ?? "";

  const { 
    required = true, 
    validate = () => "", 
    transformValue = (v) => v,
    onKeyDown
  } = options;

  const error = useMemo(() => {
    if (required && !value) return `El campo es requerido`;
    return validate(value);
  }, [value, required, validate]);

  const handleChange = useCallback(
    (e) => {
      const newValue = transformValue(e.target.value);
      dispatch(setFormValue({ field: fieldName, value: newValue }));

      const currentError = required && !newValue ? `El campo es requerido` : validate(newValue);
      dispatch(setValidValue({ field: fieldName, isValid: !currentError }));
    },
    [dispatch, fieldName, validate, required, transformValue]
  );

  const handleBlur = useCallback(() => setTouched(true), []);

  return {
    value,
    isInvalid: touched && !!error,
    getErrorMessage: () => (touched ? error : ""),
    handlers: {
      onChange: handleChange,
      onBlur: handleBlur,
      onKeyDown,
    },
  };
};
